<template>
  <v-flex xs12 sm6 md3
    :class="paddingClass"
  >
    <v-menu
      v-model="calendarVisibility"
      lazy
      transition="scale-transition"
      :close-on-content-click="false"
      offset-y
      full-width
      :max-width="maxWidth"
    >
      <v-text-field
        slot="activator"
        v-model="modification"
        readonly
        label="Ostatnia modyfikacja"
        append-icon="event"
        clearable
        placeholder="Wybierz zakres dat"
        @click:clear="clearRange()"
      ></v-text-field>
      <v-card>
        <v-layout pb-2 wrap>
          <v-flex xs12 sm6>
            <v-date-picker
              locale="pl-pl"
              color="primary"
              v-model="selectedDays"
              multiple
              no-title
              class="elevation-0"
            ></v-date-picker>
          </v-flex>
          <v-flex xs6 class="hidden-sm-and-down">
            <v-date-picker
              locale="pl-pl"
              color="primary"
              v-model="selectedDays"
              multiple
              no-title
              :show-current="false"
              class="elevation-0"
            ></v-date-picker>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions class="py-3 px-3">
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click="hideDatePicker"
            color="primary">Anuluj</v-btn>
          <v-btn
            @click="setDate"
            color="primary">Zapisz</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-flex>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import { parseDate, isAfter, getFilesRange } from '../../../helpers/helpers';

export default {
  name: 'search-by-date',
  data: () => ({
    calendarVisibility: false,
    fromDateVisibility: false,
    toDateVisibility: false,
    lastModifiedGte: [],
    lastModifiedLte: [],
    unsortedDates: [],
    range: {
      max: null,
      min: null,
    },
  }),
  computed: {
    ...mapGetters('files', [
      'query',
    ]),
    ...mapGetters('user', [
      'details',
    ]),
    clientId() {
      const { params } = this.$route;
      return params.clientId || this.details.client_id;
    },
    isSearchPage() {
      return this.$route.name === 'searchFiles';
    },
    singleParams() {
      return {
        client_id: this.clientId,
      };
    },
    paddingClass() {
      return this.$vuetify.breakpoint.xs ? 'pr-0' : 'pr-3';
    },
    maxWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '290px' : '580px';
    },
    modification: {
      get() {
        const hasDays = this.range.min && this.range.max;
        const range = `${parseDate(this.range.min)} - ${parseDate(this.range.max)}`;
        return hasDays ? range : '';
      },
      set(val) {
        if (!val) {
          this.unsortedDates = [];
        }
      },
    },
    selectedDays: {
      get() {
        return this.unsortedDates;
      },
      set(val) {
        const { length } = val;
        if (length > 2) {
          const diff = _.difference(this.unsortedDates, val);
          const newDate = diff.length === 1 ? diff[0] : val[length - 1];
          this.unsortedDates = [newDate];
          this.range = {
            min: newDate,
            max: newDate,
          };
        }
        if (length === 1) {
          this.range = {
            min: val[0],
            max: val[0],
          };
        }

        if (length === 2) {
          const newDate = val[length - 1];
          if (isAfter(this.range.min, newDate)) {
            this.range.min = newDate;
          } else {
            this.range.max = newDate;
          }
        }
        this.unsortedDates = getFilesRange(this.range);
      },
    },
  },
  methods: {
    ...mapActions('files', [
      'setQuery',
    ]),
    clearRange() {
      this.lastModifiedGte = [];
      this.lastModifiedLte = [];
      this.unsortedDates = [];
      this.range = {
        max: null,
        min: null,
      };
      const currentQuery = this.$route.query;
      const newQuery = {
        ...currentQuery,
      };
      if (newQuery.last_modified_lte) {
        delete newQuery.last_modified_lte;
      }
      if (newQuery.last_modified_gte) {
        delete newQuery.last_modified_gte;
      }
      this.setQuery(newQuery);
      this.$router.push({ path: `/pliki/klient/${this.clientId}/szukaj`, query: newQuery });
    },
    hideDatePicker() {
      this.calendarVisibility = false;
    },
    setDate() {
      if (!this.isSearchPage) {
        this.setQuery(null);
      }
      const newQuery = {
        ...this.query,
      };
      if (this.unsortedDates) {
        newQuery.last_modified_gte = this.range.min;
        newQuery.last_modified_lte = this.range.max;
      } else {
        delete newQuery.last_modified_gte;
        delete newQuery.last_modified_lte;
      }
      this.setQuery(newQuery);
      this.$router.push({ path: `/pliki/klient/${this.clientId}/szukaj`, query: newQuery });
      this.calendarVisibility = false;
    },
  },
  mounted() {
    const { query } = this.$route;
    const gte = query.last_modified_gte;
    const lte = query.last_modified_lte;
    const hasRange = gte && lte;
    if (hasRange) {
      this.range = {
        max: lte,
        min: gte,
      };
      this.unsortedDates = getFilesRange(this.range);
    }
  },
};
</script>
